import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ColorsSection from 'admin/views/site-designer/modules/sections/components/Color';
import { DESIGN_IMAGE_AWS_PATH, DESIGN_VIDEO_AWS_PATH } from 'admin/views/site-designer/data';
import Select from 'common/components/modules/select';
import ImageUploader from 'admin/views/promotions/modules/image-uploader';

// import ImageUpload from 'admin/views/my-account/new-version/legal-info/identification-content/image-upload';
import { getObjectUrl, uploadDesignImage, getS3Policy } from 'admin/api/AuthApi';
import axios from 'axios';
import randomstring from 'randomstring';
import Range from './Range'
import RadioLabel from 'common/components/elements/inputs/radio-label';
import Switch from 'common/components/elements/inputs/switch';
import CheckBox from 'common/components/elements/inputs/checkbox-label';

const OPTIONS = [
   { name: 'Color (Solid background)', icon: 'colors', value: 'color' },
   { name: 'Image', icon: 'image', value: 'image', key: 'image' },
   { name: 'Video', icon: 'video-camera', value: 'video', key: 'video' },
]

const Background = ({
   value,
   name,
   onChange,
   ...props
}) => {

   const isMobile = false;
   const { type } = value;
   const colors = props?.colors || {};
   const isPageBackgroound = false
   const [fileUploaderState, setFileUploaderState] = useState({
      image: {
         src: value?.image_src,
         full_src: value?.image_full_src,
         error: '',
         loading: false,
      },
      video: {
         src: value?.video_src,
         full_src: value?.video_full_src,
         error: '',
         loading: false,
      },
   })

   const getActiveType = () => {
      return OPTIONS.find(el => el.value === type) || {};
   }

   const onChangeBg = (key, keyValue) => {
      onChange(name, { ...value, [key]: keyValue });
   }
   const uploadIdentificationVideo = async (file, src) => {
      try {
         const client = axios.create();
         const basename = randomstring.generate(32);
         const filename = `${ basename }.mp4`;
         const s3PolicyGet = await getS3Policy();
         const s3Policy = s3PolicyGet.data;
         const key = `${ DESIGN_VIDEO_AWS_PATH }${ filename }`;
         const formData = new FormData();
         formData.append('key', key);
         formData.append('AWSAccessKeyId', s3Policy.accesskey);
         formData.append('acl', 'private');
         formData.append('success_action_status', '201');
         formData.append('policy', s3Policy.policy);
         formData.append('signature', s3Policy.signature);
         formData.append('file', file);
         client.post(
            `https://${ s3Policy.bucket }.s3.amazonaws.com`,
            formData,
            {
               headers: {
                  'Content-Type': 'multipart/form-data',
               },
            }
         );
         const path = filename;
         return Promise.resolve({
            path,
            fullPath: src,
         });
      } catch (error) {
         return Promise.reject(error);
      }
   }

   const toBase64 = file => new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
   });
   const uploadIdentificationImage = async (file) => {
      try {
         const data = new FormData();
         data.append('file', file);
         const { data: { path } } =  await uploadDesignImage(data);
         const result =  await getObjectUrl([path], DESIGN_IMAGE_AWS_PATH);
         return Promise.resolve({
            path,
            fullPath: result?.data?.[path],
         });
      } catch (error) {
         return Promise.reject(error);
      }
   }
   const handleFileChange = async (file, fileType) => {

      // const type = file.name.split('.');
      // const validFormat = ['png', 'jpeg', 'jpg'];
      // const isValid = validFormat.indexOf(type[type.length - 1].toLowerCase()) !== -1 && type.length > 1;
      // if(!isValid) {
      //    // not valid type
      //    setFileUploaderState({
      //       ...fileUploaderState,
      //       [fileType]: {
      //          full_src: '',
      //          src: '',
      //          error: 'Invalid format',
      //          loading: false,
      //       },
      //    });
      //    return;
      // }
      setFileUploaderState({
         ...fileUploaderState,
         [fileType]: {
            full_src: '',
            src: '',
            error: '',
            loading: true,
         },
      });

      let path = null;
      let fullPath = null;
      try {
         if('video' === type) {
            const targetSrc = await toBase64(file)
            const data = await uploadIdentificationVideo(file, targetSrc);
            path = data.path;
            fullPath = data.fullPath;
         } else {
            // const formData = new FormData()
            // formData.append('file', file)
            const data = await uploadIdentificationImage(file);
            path = data.path;
            fullPath = data.fullPath;
         }
         setFileUploaderState({
            ...fileUploaderState,
            [fileType]: {
               error: '',
               loading: false,
               full_src: fullPath,
               src: path,
            },
         });
         onChange(name, { ...value, [`${ fileType }_src`]: path,  [`${ fileType }_full_src`]: fullPath });
      } catch (error) {
         setFileUploaderState({
            ...fileUploaderState,
            [fileType]: {
               error: error?.message || 'Error',
               loading: false,
               full_src: '',
               src: '',
            },
         });
      }

   }
   const activeState = getActiveType();

   const view = <div className='flex flex-col gap-4'>
      <div className='border border-divider rounded-lg px-4 py-3.5 flex gap-3 justify-between'>
         <p className='font-medium text-major'>Customize for mobile</p>
         <Switch
            checked={ value?.customize_mobile_background }
            name='customize_mobile_background'
            onChange={ (_, res) => onChange(name, { ...value, customize_mobile_background: res }) }
            noHorizontalMargin
         />
      </div>
      {
         value?.customize_mobile_background &&
         <p className='text-base font-medium leading-[20px] text-major'>Mobile background</p>
      }
   </div>

   if(isPageBackgroound && !value?.customize_mobile_background && name === 'mobile_page_background') {
      return (
         <div className='flex flex-col gap-2'>
            {view}
         </div>
      )
   }

   return (
      <div className='flex flex-col gap-2'>
         {
            name === 'mobile_page_background' && view
         }
         <Select
            data={ OPTIONS }
            isMobile={ false }
            tooltipId={ `site_builder_${ name }_section_type` }
            onSelect={ (activeOption) => {
               onChangeBg('type', activeOption.value);
            } }
            name={ activeState.name }
            activeValue={ activeState.value }
            maxHeight='400px'
            className='w-full hover:bg-grey-main'
            leftIcon={ activeState.icon }
         />
         {
            'color' === type && (
               <ColorsSection
                  options={ colors }
                  value={ value.color }
                  onChange={ (name, value) => onChangeBg(name, value) }
               />
            )
         }
         {
            'color' !== type && (
               <div className='flex flex-col gap-[6px]'>
                  {
                     isPageBackgroound &&
                     <span
                        className='text-xs text-secondary leading-[15px] mt-2'
                     >
                        Recommended resolution for {name === 'mobile_page_background' ? 'mobile' : 'desktop'} is {name === 'mobile_page_background' ? '1080 x 2540' : '3840x2160' }
                     </span>
                  }
                  <div className='w-full h-[193px]'>
                     <ImageUploader
                        // screenWidth={ screenWidth }
                        isMobile={ isMobile }
                        handleChangeImage={ (file) => handleFileChange(file, activeState.key) }
                        accept={ 'image' === type ? 'image/png,image/jpeg' : 'video/*' }
                        source={ fileUploaderState?.[activeState.key]?.full_src  }
                        loading={ fileUploaderState?.[activeState.key]?.loading  }
                        errorMessage={ fileUploaderState?.[activeState.key]?.error  }
                        handleDeleteImage={ () =>   {
                           setFileUploaderState({
                              ...fileUploaderState,
                              [activeState.key]: {
                                 error: null,
                                 loading: false,
                                 full_src: '',
                                 src: '',
                              },
                           });
                           onChange(name, { ...value, [`${ activeState.key }_src`]: null,  [`${ activeState.key }_full_src`]: null })
                        } }
                        uploadImageText={ `Upload ${ type }` }
                        height={ '!h-full' }
                     />
                  </div>
                  {
                     !isPageBackgroound &&
                     <span className='text-xs text-secondary leading-[15px]'>Recommended resolution for mobile is 1080 x 2540</span>
                  }

                  <div className='flex'>
                     <CheckBox
                        name='stretch_to_fit'
                        label='Stretch to fit'
                        onChange={ onChangeBg }
                        checked={ value.stretch_to_fit }
                        textColor='major'
                        padding='0'
                     />
                  </div>
                  <div className='flex flex-col gap-4'>
                     <p className='text-major'>Blur</p>
                     <Range
                        onChange={ onChangeBg }
                        value={ value.blur }
                        name='blur'
                        minValue={ 0 }
                        maxValue={ 80 }
                        step={ 1 }
                        withTyping={ false }
                     />
                  </div>
                  <div className='flex flex-col gap-4'>
                     <p className='text-major'>Opacity</p>
                     <Range
                        onChange={ onChangeBg }
                        value={ value.opacity }
                        name='opacity'
                        minValue={ 0 }
                        maxValue={ 1 }
                        step={ 0.1 }
                        withTyping={ false }
                     />
                  </div>
               </div>
            )
         }
         {
            isPageBackgroound && 'color' !== type &&
            <div className='mt-4 flex flex-col gap-4'>
               <div className='flex flex-col gap-4'>
                  <p className='text-major'>Opacity</p>
                  <Range
                     name={ `background_opacity` }
                     value={ value?.background_opacity }
                     onChange={ (key, keyValue) => onChange(name, { ...value, [key]: keyValue }) }
                     minValue={ 0 }
                     maxValue={ 1 }
                     step={ 0.05 }
                  />
               </div>
               <p className='text-major'>Background scroll settings</p>
               <RadioLabel
                  label='Scroll up with page'
                  className='flex flex-row-reverse !justify-end gap-3 !p-0'
                  checked={ value?.background_scroll_settings === 'scroll_up_with_page' }
                  id={ `scroll_up_with_page_${ name }` }
                  radioParentClassName='!m-0'
                  onChange={ () => onChange(name, { ...value, background_scroll_settings: 'scroll_up_with_page' }) }
               />
               <RadioLabel
                  label='Parallax effect'
                  className='flex flex-row-reverse !justify-end gap-3 !p-0'
                  checked={ value?.background_scroll_settings === 'parallax_effect' }
                  id={ `parallax_effect${ name }` }
                  radioParentClassName='!m-0'
                  onChange={ () => onChange(name, { ...value, background_scroll_settings: 'parallax_effect' }) }
               />
            </div>
         }
      </div>
   );
};


Background.propTypes = {
   colors: PropTypes.array,
   inputProps: PropTypes.object,
   value: PropTypes.object,
   name: PropTypes.string,
   onChange: PropTypes.func,
   isPageBackgroound: PropTypes.any,
};
Background.defaultProps = {
   name: 'background',
   value: {},
}

export default Background;
